module.exports = __webpack_public_path__ + "img/24.7cd35669.png";